import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const CART_HEADER_LEGACY_FIELD_ORDER = [
  "text_color",
  "background_color",
  "label_color",
  "icon_color",
  "icon_background_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartHeaderBlockDescriptor: _generatedCartHeaderBlockDescriptor,
  cartHeaderBlockBlocDefinition,
  cartHeaderBlockDashboardLayout,
  cartHeaderBlockConfig,
  cartHeaderBlockResolveConfig,
  cartHeaderBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart - Header",
    componentType: "CartHeaderBlockComponent",
    category: "cart",
    description: "Cart page header.",
    keywords: ["cart", "header"],
    allowedIn: [
      { bloc: 'CartPageComponent', slot: '*' },
    ],

    sharedFields: {},
  },

  () => ({
    text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-900" },
      options: { label: "pages.blocks.cart-header.text-color.label" },
    }),
    background_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "#FFFFFF" },
      options: { label: "pages.blocks.cart-header.background-color.label" },
    }),
    label_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-800" },
      options: { label: "pages.blocks.cart-header.label-color.label" },
    }),
    icon_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-600" },
      options: { label: "pages.blocks.cart-header.icon-color.label" },
    }),
    icon_background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-100" },
      options: { label: "pages.blocks.cart-header.icon-background-color.label" },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-header.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-header.fieldset.back-header.label",
            fields: ["text_color", "background_color"],
          },
          {
            legend: "pages.blocks.cart-header.fieldset.order-parameters.label",
            fields: ["label_color", "icon_color", "icon_background_color"],
          },
        ],
      },
    ],
  }),
);

export function cartHeaderBlockDescriptor(): IBlockDescriptor;
export function cartHeaderBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartHeaderBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartHeaderBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedCartHeaderBlockDescriptor,
    cartHeaderBlockProperties,
    fieldOrder,
  );
}

export {
  cartHeaderBlockBlocDefinition,
  cartHeaderBlockDashboardLayout,
  cartHeaderBlockConfig,
  cartHeaderBlockResolveConfig,
  cartHeaderBlockProperties,
};

export type CartHeaderBlockConfig = typeof cartHeaderBlockConfig;
